import styled from '@emotion/styled';

export {
	AuthContainer as Container,
	AuthFormActions as FormActions,
	AuthFormCard as FormCard,
	AuthPage as Page,
} from '@/styles/authPageLayout';

export { PrimaryButton as NextButton } from '@/components/common/Button/style';

export const CompleteBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${(props) => props.theme.scale.spaceLg};
	width: 100%;
	text-align: center;
`;

export const IconWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 5.6rem;
	height: 5.6rem;
	border-radius: 50%;
	background: ${(props) => props.theme.colors.primary50};
	color: ${(props) => props.theme.colors.primary400};
	font-size: 2.4rem;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;

export const Title = styled.p`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 1.45;
	color: ${(props) => props.theme.ui.text.primary};

	strong {
		color: ${(props) => props.theme.ui.interactive.primary};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;
